module.exports = __webpack_public_path__ + "static/media/windshield.8ba4d3af.jpeg";